import React, { ComponentProps, CSSProperties } from 'react';
import { 
  Spin, 
  Table, 
  Image, 
  Space,
} from 'antd';
import { ColumnGroupType, ColumnType } from 'antd/lib/table';
import { ExpandableConfig, TableRowSelection } from 'antd/lib/table/interface';
import { UsePaginationService } from '@/hooks/usePaginationService';
import DebounceSearch from '../../form/DebounceSearch';

const customLoader = import.meta.env.VITE_LOADER;
const defaultLoader = `${import.meta.env.VITE_API_URL}/images/loader.png`;

if (customLoader) {
  Spin.setDefaultIndicator(
    <Image
      width={120}
      height={120}
      style={{ objectFit: 'contain' }}
      preview={false}
      src={customLoader}
      fallback={defaultLoader}
    />);
}

interface SearchableTableProps {
  data: any;
  columns: (ColumnGroupType<any> | ColumnType<any>)[];
  pagination?: UsePaginationService<any>;
  placeholder?: string;
  disableSearch?: boolean;
  onSearch?: (value: any) => void;
  onChange?: (value: any) => void;
  children?: React.ReactNode;
  subhead?: string;
  loading?: boolean;
  rowKey?: string;
  expandable?: ExpandableConfig<any>;
  rowSelection?: TableRowSelection<any>;
  onRow?: ComponentProps<any>;
  style?: CSSProperties;
}

const SearchableTable = ({
  pagination,
  data,
  columns,
  placeholder,
  loading,
  subhead,
  children,
  expandable,
  rowSelection,
  onRow,
  style,
  rowKey = 'id',
  disableSearch = false,
  onSearch,
  onChange,
}: SearchableTableProps) => (
  <>
    {
      (subhead || children) ? (
        <div className="react-table__wrapper">
          {subhead && <p className="subhead">{subhead}</p>}
          <Space>
            {children}
          </Space>
        </div>
      ) : null
    }
    {
      !disableSearch ? (
        <DebounceSearch 
          placeholder={placeholder}
          allowClear
          onSearch={onSearch || (() => { })}
          onChange={onChange}
          style={{ marginBottom: 12 }}
        />
      ) : null
    }
    <Table
      scroll={{ x: true }}
      pagination={pagination?.pagination || false}
      style={{ 
        whiteSpace: 'nowrap',
        ...style, 
      }}
      loading={loading}
      rowKey={rowKey}
      onChange={(paginationChange: any) => {
        pagination?.setCurrentPageSize(paginationChange.pageSize);
        pagination?.setCurrentPage(paginationChange.current);
      }}
      dataSource={data}
      columns={columns}
      footer={() => <div style={{ height: '1px' }} />}
      expandable={expandable}
      rowSelection={rowSelection}
      onRow={onRow}
    />
  </>
);

export default SearchableTable;
